<template>
  <l-cache ref="cache" :get-data="getItem" :id="this.$route.query.id">
    <reservation-info :authority="auth" slot-scope="{data}" :reservation="data">
      <template slot="title-actions">
        <v-btn flat color="primary" class="mx-0" @click="$refs.cache.retry()">刷新</v-btn>
        <v-btn flat color="primary" class="mx-0" @click="goReservationGroup(data)">查看分组</v-btn>
      </template>
    </reservation-info>
  </l-cache>
</template>

<script>
import {Reservation} from '../../../object'
import ReservationInfo from '../Common/reservationInfo'

export default {
  name: 'PersonAdminReservationDetails',
  components: {ReservationInfo},
  computed: {
    auth () {
      return this.$store.state.reservation.adminAuth
    }
  },
  methods: {
    async getItem (key) {
      let {items} = await this.$store.dispatch('personReservation/getReservations', {
        pagination: {},
        search: {key: 'id', value: key},
      })
      if (items.length) {
        try {
          let des = JSON.parse(items[0].description).comment
          items[0].description = des
        }
        catch (e) {

        }
        return items[0]
      }
      else {
        throw Error('未找到该预约')
      }
    },
    goReservationGroup (item) {
      console.log(item)
      if (item.groupId) {
        this.$router.push({
          name: 'PersonReservationGroupDetails',
          params: {id: item.groupId},
        })
      }
      else {
        this.$L.alert('success snackbar', '分组未设置')
      }
    },
  },
}
</script>

<style scoped>

</style>
